// src/data/faq.js
export const faqItems = [
  {
    question: '未経験でも大丈夫？',
    answer:
      'もちろん大丈夫です！有名店では経験者優遇もありますが、未経験に特化した当サイトのサポートで安心スタート可能です♪',
  },
  {
    question: '高校生でも働けますか？',
    answer:
      'ごめんなさい…法律で現役高校生の勤務は禁止されています。卒業年の4月2日以降なら大歓迎です！',
  },
  {
    question: '学生や、本業でまとまったシフトで出勤できなくても大丈夫？',
    answer:
      '全然OK！シフトが自由なお店をご紹介できるので、学業やお仕事とムリなく両立できますよ',
  },
  {
    question: 'お酒が飲めないと働けませんか？',
    answer: '飲めなくても全く問題なし！ノンアルドリンクで接客してる女の子もたくさんいますよ。',
  },
  {
    question: '面接時に必要なものは？',
    answer:
      '身分証（免許証やマイナンバーカード、パスポートなど）だけで大丈夫です！服装も清潔感があればOK♪迷ったらLINEで聞いてくださいね。',
  },
  {
    question: '相談だけでもOKですか？',
    answer:
      'もちろんOKです！「まずは話だけ聞きたい」って方も多いので、気軽にLINEしてくださいね。無理に紹介したりはしません♪',
  },
  {
    question: '夜遅くに帰るのが心配なんですが…',
    answer:
      'そうですよね、深夜の帰り道って不安ありますよね。でも大丈夫！終電後の送りがあるお店も多いので、安心して帰れますよ♪',
  },
  {
    question: 'ヘアメイクとか自分でやらなきゃダメ？',
    answer:
      'プロのヘアメイクさんがいるお店と提携もあるので安心してくださいね♪ドレスの貸出もあるので、学校終わりやお仕事終わりに手ぶらで出勤OK！',
  },
];

export default faqItems;
